<template>
  <div class="main-content-container container-fluid px-4">
    <!-- Page Header -->
    <div class="page-header row no-gutters py-4">
      <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">List</span>
        <h3 class="page-title">User</h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="card card-small mb-4">
          <div class="card-header border-bottom">
             <d-button type="button" :disabled="loading" class="btn-accent" @click="add_new" data-toggle="tooltip" data-placement="top" title="Tambah Baru" ><i class="material-icons">note_add</i> Tambah Baru</d-button>
          </div>
          <div class="card-body p-0 pb-3 text-center" style="overflow-x:scroll">
            <d-row style="margin:auto">
            <d-col md="4"  class="form-group" style="text-align:left">
              Menampilkan 
              <select v-model="ipp" >
                <option value="5" selected>5 item</option>
                <option value="10">10 item</option>
                <option value="15">15 item</option>
                <option value="20">20 item</option>
                <option value="0">Semua</option>
              </select>          
            </d-col>
            <d-col md="4"  class="form-group">
            </d-col>
            <d-col md="4"  class="form-group">
              <d-form-input type="text" id="feInputAddress" placeholder="Cari" v-model.trim="search" />
            </d-col>
            </d-row>
        <b-table
            :data="isEmpty ? [] : data"
            :loading="loading"
            :mobile-cards="hasMobileCards"
            paginated
            backend-pagination
            :total="total"
            :per-page="perPage"
            @page-change="onPageChange"
            :sort-icon="sortIcon"
            :sort-icon-size="sortIconSize"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"

            backend-sorting
            :default-sort-direction="defaultSortOrder"
            :default-sort="[sortField, sortOrder]"
            @sort="onSort"            
            >

            <template slot-scope="props">
                <b-table-column field="id" label="Id" sortable>
                    <span class="tag is-success">
                    {{ props.row.id }}
                    </span>
                </b-table-column>

                <b-table-column field="email" label="Email" sortable>
                    {{ props.row.email }}
                </b-table-column>

                <b-table-column field="fullname" label="Nama" sortable>
                    {{ props.row.fullname }}
                </b-table-column>

                <b-table-column field="active" label="Aktif" sortable>
                  <d-checkbox v-model="props.row.active" @change="toggle_active(props.row.id,props.row.active)"  toggle />                  
                </b-table-column>

                <b-table-column field="admin" label="Admin" sortable>
                  <d-checkbox v-model="props.row.admin" @change="toggle_admin(props.row.id,props.row.admin)"  toggle />                  
                </b-table-column>

            </template>

            <template slot="empty">
                <section class="section">
                    <div class="content has-text-grey has-text-centered">
                        <p>
                            <b-icon
                                icon="emoticon-sad"
                                size="is-large">
                            </b-icon>
                        </p>
                        <p>Nothing here.</p>
                    </div>
                </section>
            </template>
        </b-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import env from '../env.vue';

    export default {
        data() {
            return {
                data:[],
                cost: false,
                isEmpty: false,
                isHoverable: true,
                loading: false,
                hasMobileCards: true,
                sortField:'name',
                sortOrder:'asc',
                sortIcon:'arrow-up',
                sortIconSize:'is-small',
                sort:'name',
                defaultSortOrder:'asc',
                page:1,
                perPage:5,
                total:2,
                ipp:5,
                search:'',
            }
        },
        watch:{
          ipp(){
           if (this.ipp>0) this.perPage=this.ipp
           else this.perPage=this.total
           this.update_data();
          },
          search(){
           if(this.search.length>3||!this.search.length)this.update_data()
          }
        },
        methods:{

          add_new(){
            this.$router.push({name:'user-form',params:{id:0},query:{id:0}});
          },

          open_data(id){
            this.$router.push({name:'user-form',params:{id:id},query:{id:id}});
          },

          toggle_active(id,active){
           let action="activate";
           if ( active ) action="de"+action;
           this.axios.get( env.server+'/user/'+action+'/'+id
           ).then(
             resp=>{
               this.loading=false;
             }
           );
          },
          toggle_admin(id,active){
           let action="activate";
           if ( active ) action="de"+action;
           this.axios.get( env.server+'/admin/'+action+'/'+id
           ).then(
             resp=>{
               resp.data=JSON.parse(resp.data);
               this.loading=false;
             }
           );
          },
          onPageChange(page){
           this.page=page;
           this.update_data();
          },
          onSort(field,order){
           if ( !this.loading ){           
            this.sortField=field;
            this.sortOrder=order;
            this.update_data();
           }
          },
          update_data(){
           this.loading=true;
           this.axios.post( env.server+'/user-list',{
             start: this.page,
             length: this.perPage>0 ? this.perPage: this.total,
             sort: this.sortField,
             sort_order: this.sortOrder,
             scfilter: this.search,
           }).then(
             resp=>{
               resp.data=JSON.parse(resp.data);
               this.loading=false;
               this.data=resp.data.data.items;
               this.total=resp.data.data.total_results;
             }
           );
          },
        },
        mounted(){
          this.update_data();
        },
    }
</script>
